import { Helmet } from "react-helmet-async";

const SITE_URL = "https://konyapmuhendislik.com";
const DEFAULT_IMAGE = "/images/2-anasayfa/anasayfa.jpg";
const DEFAULT_TITLE = "Konyap Mühendislik | Konya İnşaat ve Villa Projeleri";
const DEFAULT_DESCRIPTION =
  "Konya'da modern konut ve villa projeleri üreten Konyap Mühendislik. Saklı Bahçe, Villa Selver ve diğer prestijli projeler.";

const toAbsoluteUrl = (value) => {
  if (!value) return `${SITE_URL}${DEFAULT_IMAGE}`;
  if (/^https?:\/\//i.test(value)) return value;
  return `${SITE_URL}${value.startsWith("/") ? value : `/${value}`}`;
};

const normalizePath = (path) => {
  if (!path || path === "/") return "/";
  return path.startsWith("/") ? path : `/${path}`;
};

const SeoMeta = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  schema = null,
}) => {
  const normalizedPath = normalizePath(path);
  const canonicalUrl = `${SITE_URL}${normalizedPath}`;
  const imageUrl = toAbsoluteUrl(image);
  const robotsValue = noindex
    ? "noindex, nofollow"
    : "index, follow, max-image-preview:large";

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsValue} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="Konyap Mühendislik" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={title} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={title} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SeoMeta;
